module.exports = __webpack_public_path__ + "img/INTERIOR-SCROSS-7.db804626.jpg";